const SIGN_IN_PENDING_KEY = 'auth.signInPending'

export const setSignInPending = (): void => {
  sessionStorage.setItem(SIGN_IN_PENDING_KEY, '1')
}

export const consumeSignInPending = (): boolean => {
  const value = sessionStorage.getItem(SIGN_IN_PENDING_KEY) === '1'
  if (value) sessionStorage.removeItem(SIGN_IN_PENDING_KEY)
  return value
}

export const clearSignInPending = (): void => {
  sessionStorage.removeItem(SIGN_IN_PENDING_KEY)
}
